import * as endpoints from './endpoints';

const DropshipmentService = { ...endpoints };

export default DropshipmentService;
export type {
  AddressSuggestion, OrderAddress, DeviceOrder, OrderProduct, AddressVerifyResult,
} from './endpoints';
